import React from 'react';
import './ContactBanner.css';

function ContactBanner() {
  return (
    <div className='contact-banner'>
      <div className='contact-banner-content'>
        <h2 className='contact-banner-heading'>CONTACT WITH SPIRIT</h2>
        <p className='contact-banner-para'>
            At Spirit Air Cargo, we are committed to providing the
        </p>
        <p className='contact-banner-para2'> Best Service</p>
      </div>
      <div
        className='contact-banner-image'
        style={{ backgroundImage: "url('/images/ContactUsBanner.jpg')" }}
        />
    </div>
  );
}

export default ContactBanner;